import React, { createContext, useContext, useCallback, useMemo } from 'react'

import type { DragDropFileContextValue, DragDropFileProviderProps, FileWithStatus } from './types'

export const DragDropFileContext = createContext<DragDropFileContextValue | undefined>(undefined)

export const DragDropFileProvider = ({
  fileList,
  onFilesAdded,
  onFileRemoved,
  onRetryUpload,
  children,
}: DragDropFileProviderProps): JSX.Element => {
  const onRemoveFile = useCallback(
    (removedItem: FileWithStatus, index: number) => {
      onFileRemoved([...fileList.slice(0, index), ...fileList.slice(index + 1)], removedItem, index)
    },
    [fileList]
  )

  const contextValue = useMemo(() => ({ fileList, onFilesAdded, onRemoveFile, onRetryUpload }), [
    fileList,
    onFilesAdded,
    onRemoveFile,
    onRetryUpload,
  ])

  return (
    <DragDropFileContext.Provider value={contextValue}>{children}</DragDropFileContext.Provider>
  )
}

export const useDragDropFileContext = (): DragDropFileContextValue => {
  const context = useContext(DragDropFileContext)

  if (!context) {
    throw new Error('useDragDropFileContext must be used within an DragDropFileProvider')
  }

  return context
}
